var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "调价记录",
        width: "700px",
        "close-on-click-modal": false,
        "show-close": true,
        "custom-class": "price-record-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "dialog-body",
        },
        [
          _vm.recordList.length > 0
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "record-header" }, [
                    _c("span", { staticClass: "header-label" }, [
                      _vm._v("商品名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.recordList[0] && _vm.recordList[0].skuName
                            ? _vm.recordList[0].skuName
                            : "--"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-divider" }, [
                      _vm._v("|"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-label" }, [
                      _vm._v("商品编号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-value" }, [
                      _vm._v(_vm._s(_vm.currentSkuId || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.recordList,
                        "header-cell-style": {
                          background: "#f5f7fa",
                          color: "#333",
                          fontWeight: "600",
                        },
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "调整比例",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { class: _vm.getRatioClass(scope.row) },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getRatioText(scope.row))
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4274825163
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operatorName",
                          label: "调整人",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "调整时间",
                          "min-width": "180",
                          align: "center",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : !_vm.loading
            ? _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无调价记录")])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }